/**
 * @generated SignedSource<<d77f3184acb93140cebf6a3d5b19aa44>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type main_issueNavigator_CardWithSelectedIssue_fragment$data = {
  readonly key: string;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_Card_fragment">;
  readonly " $fragmentType": "main_issueNavigator_CardWithSelectedIssue_fragment";
};
export type main_issueNavigator_CardWithSelectedIssue_fragment$key = {
  readonly " $data"?: main_issueNavigator_CardWithSelectedIssue_fragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"main_issueNavigator_CardWithSelectedIssue_fragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "main_issueNavigator_CardWithSelectedIssue_fragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "key"
    },
    {
      "kind": "FragmentSpread",
      "name": "main_issueNavigator_Card_fragment"
    }
  ],
  "type": "JiraIssue"
};

(node as any).hash = "193ffe36e5f982599fda1349dc93ab4d";

export default node;
